import { View } from 'backbone';
import {Model} from 'backbone';
import _template from 'properties/table/column-main-form-name.ejs';
import selectFieldModal from 'common-views/SelectFieldModalView';
import SelectFormOrReportModal from 'common-views/SelectFormOrReportModalView.js'

// PF-5745
import undoService from 'UndoService.js';
import textConstants from 'TextConstants';

class MainFormSelectView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;
        this.colId = this.model.get('selectedRowId');

        this.events = {
            'click #selectedFormButton' : 'selectForm'
        };





        return this;
    }



    updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;

        this.model.get('gridData')[this.colId].attributes[propName] = propVal;
    }

    selectForm() {
        console.log('Form Selected');
        var sfModal = new SelectFormOrReportModal({
            model: new Model(),
            mode: 'form',
            checkForInstances: false
        });
        sfModal.render().then((selectedFormOrReport)=> {
            // Grabbing the chosen report form data.
            //console.log("Returned Form Data", selectedFormOrReport);
            const prevFormName = this.model.get('gridData')[this.colId].attributes['formName'];
            const prevFormId = this.model.get('gridData')[this.colId].attributes['formId'];
            const prevLinkId = this.model.get('gridData')[this.colId].attributes['linkId'];
            const prevFormGUID = this.model.get('gridData')[this.colId].attributes['formGUID'];

            const formName = selectedFormOrReport.name;
            const formId = selectedFormOrReport.id;
            const linkId = selectedFormOrReport.linkId;
            const formGUID = selectedFormOrReport.GUID;

            const tempColId = this.colId;


            this.model.get('gridData')[tempColId].attributes['formName'] = formName;
            this.model.get('gridData')[tempColId].attributes['formId'] = formId;
            this.model.get('gridData')[tempColId].attributes['linkId'] = linkId;
            this.model.get('gridData')[tempColId].attributes['formGUID'] = formGUID;

            $("input[name='formName']").val(formName);

            // PF-5745
            undoService.add({
                undo: () =>{
                    this.model.get('gridData')[tempColId].attributes['formName'] = prevFormName;
                    this.model.get('gridData')[tempColId].attributes['formId'] = prevFormId;
                    this.model.get('gridData')[tempColId].attributes['linkId'] = prevLinkId;
                    this.model.get('gridData')[tempColId].attributes['formGUID'] = prevFormGUID;
                    $("input[name='formName']").val(prevFormName);
                },
                redo:() => {
                    this.model.get('gridData')[tempColId].attributes['formName'] = formName;
                    this.model.get('gridData')[tempColId].attributes['formId'] = formId;
                    this.model.get('gridData')[tempColId].attributes['linkId'] = linkId;
                    this.model.get('gridData')[tempColId].attributes['formGUID'] = formGUID;
                    $("input[name='formName']").val(formName);
                }
            }, textConstants.UNDO_MOVE);
        })
    }


    showBrowseFormsWindow() {
        ev.preventDefault();
        var sfModal = new selectFieldModal({model: new Model()});
        sfModal.render().then((selectedField)=>{
            // used only for display in the UI
            this.model.set('formName', selectedField.name, {silent: true});

            const parameter = this.getParameter();
            parameter.field = selectedField.id;

            this.selectValue('field', selectedField.id);
        });
    }

    render() {
        this.$el.empty();
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainFormSelectView;
